import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  inputsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  description: {
    gridColumn: '1/3'
  },
  mainCheckBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-root': {
      marginRight: 0
    }
  }
}))
export default useStyles
